import axios from 'axios';

class UtilidadesDataService {
  getAll() {
    return axios.get(`/api/utilidades`);
  }

  getSimple() {
    return axios.get(`/api/utilidades/search`);
  }

  get(id) {
    return axios.get(`/api/utilidades/${id}`);
  }

  create(data) {
    return axios.post(`/api/utilidades`, data);
  }

  update(id, data) {
    return axios.put(`/api/utilidades/${id}`, data);
  }

  delete(id) {
    return axios.delete(`/api/utilidades/${id}`);
  }

  deleteAll() {
    return axios.delete(`/api/utilidades`);
  }
}

export default new UtilidadesDataService();